<div class="mb-8">

    <div class="w-full flex justify-between mt-8 mb-4">
        <app-btn-back routeTo=".." icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="w-full flex flex-col mb-4 gap-4">
        <div>
            <h1 class="font-semibold text-2xl capitalize text-primary-500 mb-0">Edit Event</h1>
            @if (group) {
            <div class="flex items-center gap-2 text-primary-300 text-sm mt-1">
                <span>Editing event for</span>
                @if (group.imageUrl) {
                <img [src]="group.imageUrl" class="h-6 w-6 rounded-full object-cover border border-blueGray-200" />
                } @else {
                <div
                    class="h-6 w-6 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-[10px]">
                    {{group.name | initials}}
                </div>
                }
                <span class="font-semibold text-blueGray-700">{{group.name}}</span>
            </div>
            }
        </div>
    </div>

    <div class="w-full py-2">
        <form [formGroup]="pageForm" (ngSubmit)="update()">

            <div class="flex flex-wrap">

                <div class="w-full mb-6">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Event Image
                    </label>
                    <p class="text-xs text-primary-300 block">(Defaults to Group Image)</p>
                    <p class="text-xs text-primary-300">Image file up to 5 Mb only</p>
                    <div class="flex flex-row gap-4 mt-2 w-full">
                        <div *ngIf="currentEventImage" class="relative rounded shadow-lg w-[130px]">
                            <img [src]="currentEventImage" class="rounded shadow h-[130px] w-full object-cover" />
                            <button (click)="currentEventImage = null"
                                class="absolute h-12 w-12 top-10 left-10 bg-white text-red-500 hover:bg-red-500 hover:text-white text-sm uppercase font-bold px-4 py-2 rounded-full outline-none focus:outline-none shadow-lg ease-linear transition-all duration-150"
                                type="button"><i class="fa fa-trash"></i>
                            </button>
                        </div>
                        <div class="rounded h-[130px] grow">
                            <uppy-dashboard [uppy]="uppy" [props]="dashboardProps"></uppy-dashboard>
                        </div>
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Name *
                    </label>
                    <input type="text" type="name" formControlName="name" id="name" name="name" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                    <div
                        class="{{ pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('name')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="pageForm.get('name')?.errors?.['minlength'] || pageForm.get('name')?.errors?.['maxlength']">
                            Min 10 and max 50 characters required
                        </p>
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        rows="4">
                </textarea>
                    <div
                        class="{{ pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('description')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="pageForm.get('description')?.errors?.['minlength'] || pageForm.get('description')?.errors?.['maxlength']">
                            Min 10 and max 500 characters required
                        </p>
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-4 w-full mb-1">
                    <div class="flex flex-col gap-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Start Date *
                        </label>
                        <input type="date" name="startDate" formControlName="startDate" placeholder="DD/MM/YYYY"
                            class="border-0 px-3 py-2 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            [min]="moment" [max]="moment().add(3, 'month')">
                        <div
                            class="{{ pageForm.get('startDate')?.invalid && (pageForm.get('startDate')?.dirty || pageForm.get('startDate')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('startDate')?.errors?.['required']">
                                Value is required
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            End Date *
                        </label>
                        <input type="date" formControlName="endDate" id="endDate" name="endDate"
                            placeholder="DD/MM/YYYY" required
                            class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                        <div
                            class="{{ pageForm.get('endDate')?.invalid && (pageForm.get('endDate')?.dirty || pageForm.get('endDate')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('endDate')?.errors?.['required']">
                                Value is required
                            </p>
                            <p *ngIf="pageForm.errors?.['invalid-end-date']">End date must be after Start date</p>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-4 w-full mb-1">
                    <div class="flex flex-col gap-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Start Time *
                        </label>
                        <input type="time" name="startTime" formControlName="startTime"
                            class="border-0 px-3 py-2 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            [min]="moment" [max]="moment().add(3, 'month')">
                        <div
                            class="{{ pageForm.get('startTime')?.invalid && (pageForm.get('startTime')?.dirty || pageForm.get('startTime')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('startTime')?.errors?.['required']">
                                Value is required
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            End Time *
                        </label>
                        <input type="time" formControlName="endTime" id="endTime" name="endTime" required
                            class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                        <div
                            class="{{ pageForm.get('endTime')?.invalid && (pageForm.get('endTime')?.dirty || pageForm.get('endTime')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('endTime')?.errors?.['required']">
                                Value is required
                            </p>
                            <p *ngIf="pageForm.errors?.['invalid-end-time']">End time must be after Start time</p>
                        </div>
                    </div>
                </div>
                <!-- Calendar Sub-Events Section -->
                <div class="w-full mb-6 p-4 bg-blueGray-50/50 border border-blueGray-200/60 rounded-xl">
                    <div class="mb-4 pb-2 border-b border-blueGray-200/50">
                        <div class="flex justify-between items-center">
                            <label class="form-label font-bold text-xs uppercase text-blueGray-600 tracking-wide">
                                Sessions / Sub-Events
                            </label>
                            <button type="button" (click)="addEventRow()"
                                class="text-xs font-bold text-primary-500 hover:text-primary-600 flex items-center gap-1.5 bg-white hover:bg-blueGray-50 px-3 py-1.5 rounded-lg shadow-sm border border-blueGray-200 transition-all duration-150">
                                <i class="fa fa-plus"></i> Add Session
                            </button>
                        </div>
                        <span class="text-xs text-primary-300 font-normal block">Add individual sessions/schedule for
                            this event</span>
                    </div>

                    <div formArrayName="events" class="space-y-4">
                        @for (g of eventsArray.controls; track $index; let i = $index) {
                        <div class="flex flex-row items-start gap-2 w-full">
                            <!-- Sub-Event Card -->
                            <div [formGroupName]="i"
                                class="flex flex-col gap-3 p-4 bg-white border border-blueGray-200/80 rounded-xl shadow-sm flex-1">
                                <div class="flex flex-col md:flex-row items-end gap-3 w-full">
                                    <div class="flex flex-col flex-1">
                                        <label class="font-bold text-[10px] uppercase text-blueGray-600 mb-1">
                                            Date & Time *
                                        </label>
                                        <input type="datetime-local" formControlName="date" required
                                            class="placeholder-blueGray-300 text-blueGray-600 bg-white border border-blueGray-200 rounded text-sm shadow-inner focus:outline-none focus:ring-0 w-full py-1.5 px-3" />
                                    </div>

                                    <div class="flex flex-col flex-1">
                                        <label class="font-bold text-[10px] uppercase text-blueGray-600 mb-1">
                                            Session Name *
                                        </label>
                                        <input type="text" formControlName="name"
                                            placeholder="e.g. Session 1, Presentation" required
                                            class="placeholder-blueGray-300 text-blueGray-600 bg-white border border-blueGray-200 rounded text-sm shadow-inner focus:outline-none focus:ring-0 w-full py-1.5 px-3" />
                                    </div>
                                </div>

                                <!-- Volunteer Section for Sub-Event -->
                                <div class="w-full border-t border-blueGray-100 pt-3">
                                    <div class="flex items-center gap-2 mb-2">
                                        <input type="checkbox" formControlName="requestVolunteers"
                                            [id]="'requestVolunteers_' + i"
                                            class="rounded border-blueGray-300 text-primary-500 focus:ring-0 focus:ring-offset-0 focus:outline-none outline-none h-4 w-4" />
                                        <label [for]="'requestVolunteers_' + i"
                                            class="text-xs font-semibold text-blueGray-700 cursor-pointer select-none">
                                            Request Volunteers for this Session
                                        </label>
                                    </div>

                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 bg-blueGray-50 border border-blueGray-200 rounded-lg shadow-inner transition-all duration-200"
                                        [class.opacity-50]="!g.get('requestVolunteers')?.value"
                                        [class.pointer-events-none]="!g.get('requestVolunteers')?.value">
                                        <div class="flex flex-col">
                                            <label class="block uppercase text-blueGray-500 text-[10px] font-bold mb-1">
                                                Volunteers Required
                                            </label>
                                            <input type="number" formControlName="volunteersRequired"
                                                [readOnly]="!g.get('requestVolunteers')?.value"
                                                class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-xs shadow-sm focus:ring-0 py-1.5 px-2 outline-none" />
                                        </div>
                                        <div class="flex flex-col">
                                            <label class="block uppercase text-blueGray-500 text-[10px] font-bold mb-1">
                                                Eligibility & Criteria
                                            </label>
                                            <input type="text" formControlName="volunteerCriteria"
                                                placeholder="Criteria to volunteer..."
                                                [readOnly]="!g.get('requestVolunteers')?.value"
                                                class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-xs shadow-sm focus:ring-0 py-1.5 px-2 outline-none" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Delete button outside the card -->
                            <app-btn-fab (click)="removeEventRow(i)" bgColor="bg-transparent hover:bg-red-500"
                                textColor="text-red-500 hover:text-white" icon="fa fa-trash"></app-btn-fab>
                        </div>
                        }

                        @if (eventsArray.length === 0) {
                        <div class="text-center py-6 text-sm text-blueGray-400">
                            No sessions added.
                        </div>
                        }
                    </div>
                </div>

                <div class="w-full mb-2">
                    <div class="w-full rounded h-128 mb-4">
                        <app-add-location [location]="pageForm.get('position')?.value"
                            (locationChange)="setPosition($event)" label="Event Location"
                            description="Location is required if you want AtChurch users outside your group to find this event around their location"></app-add-location>
                    </div>
                </div>
                <div class="w-full mb-6">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Location Name
                    </label>
                    <p class="text-xs text-primary-300 mb-2">(Defaults to Event Name)</p>
                    <input type="text" type="locationName" formControlName="locationName" id="locationName"
                        name="locationName"
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                </div>

                <div class="w-full mb-4">
                    <input formControlName="isPrivate" name="isPrivate" id="isPrivate" type="checkbox"
                        class="ml-1 w-4 h-4 text-secondary-500 rounded focus:outline-none focus:ring-0">
                    <label class="uppercase text-blueGray-600 text-xs ml-1 font-bold">
                        Private Event
                    </label>
                    <p class="text-xs text-primary-300 mt-1">Private event only visible to group members</p>
                </div>

                <div class="w-full mb-1">
                    <app-btn-submit [isDisabled]="!pageForm.valid || working" [isLoading]="working"
                        [actionText]="'Update'" [icon]="'fa fa-save'"></app-btn-submit>
                </div>
            </div>
        </form>
    </div>
</div>